<template>
  <v-row>
    <v-col class="px-0">
      <v-card outlined>
        <v-card-title class="clickable" @click="switchCard()">
          <v-row class="no-gutters justify-space-between">
            <v-col class="col-auto">
              {{ $t('stornoHistory.exportVoucher') }}
            </v-col>
            <v-col class="col-auto">
              <v-btn icon>
                <span v-if="cardOpen" class="fal fa-chevron-up fa-2x" />
                <span v-else class="fal fa-chevron-down fa-2x" />
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-expand-transition>
          <v-card-text v-if="cardOpen">
            <v-form
              ref="accountingExportForm"
              v-model="voucherExportValid"
              class="py-4"
            >
              <v-row>
                <v-col class="col-12 py-0">
                  <s-date-picker
                    :date.sync="lastDate"
                    :label="$t('reportsOverview.to')"
                    :rules="[(v) => !!v || $t('reportsOverview.required')]"
                  />
                </v-col>
              </v-row>

              <v-row>
                <!-- download excel button -->
                <v-col class="col-12 text-center pt-0">
                  <v-btn
                    color="primary"
                    outlined
                    :disabled="!voucherExportValid"
                    large
                    @click="
                      voucherExporter.downloadVoucherExcel(new Date(lastDate))
                    "
                  >
                    <i class="fad fa-file-spreadsheet mr-2" />
                    {{ $t('stornoHistory.excelDownload') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-expand-transition>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import VoucherExport from '@/classes-shared/cancellation/VoucherExport'
import SDatePicker from '@/components-shared/utils/SDatePicker'

export default {
  name: 'VoucherExport',

  components: {
    SDatePicker,
  },

  data() {
    return {
      voucherExporter: new VoucherExport(),

      lastDate: null,
      voucherExportValid: false,
      cardOpen: false,
    }
  },

  watch: {
    lastDate() {
      this.$refs.accountingExportForm.validate()
    },
  },
  methods: {
    switchCard() {
      this.cardOpen = !this.cardOpen
    },
  },
}
</script>
